// Generated by Melange

import * as Belt__Belt_Option from "melange.belt/belt_Option.js";
import * as Buhta_cabinet__Btn from "../../../html/Btn.js";
import * as Buhta_cabinet__CalendarDatePickerInput from "../../../molecules/CalendarDatePickerInput.js";
import * as Buhta_cabinet__Checkbox from "../../../html/Checkbox.js";
import * as Buhta_cabinet__Date from "../../../../util/Date.js";
import * as Buhta_cabinet__Field from "../../../html/Field.js";
import * as Buhta_cabinet__TaxControl from "../../../../grpc/TaxControl.js";
import * as Buhta_cabinet__Toggle from "../../../atoms/Toggle.js";
import * as Buhta_components__Text from "../../../../../../../packages/components/src/html/Text.js";
import * as Buhta_core__GrpcState from "../../../../../../../packages/core/lib/GrpcState.js";
import * as Caml_format from "melange.js/caml_format.js";
import * as Cn from "../../../../../../../vendored/classnames/Cn.js";
import * as Curry from "melange.js/curry.js";
import * as DateTime from "../../../../../../../packages/util/lib/DateTime.js";
import * as MelNumeral from "../../../../../../../packages/util/lib/MelNumeral.js";
import * as StaticAsset from "../../../../../../../packages/util/lib/StaticAsset.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

function make(goToPrevious) {
  return function (goToNext) {
    const func = Buhta_cabinet__TaxControl.ChiefInformationService.view;
    const match = Buhta_core__GrpcState.useModel((function (param) {
            return Curry._2(func, param, /* [] */0);
          }), undefined);
    const dispatch = match[1];
    const settings = match[0];
    React.useEffect((function () {
            Curry._2(dispatch, undefined, undefined);
          }), []);
    const match$1 = React.useState(function () {
          return "";
        });
    const setBirthday = match$1[1];
    const match$2 = React.useState(function () {
          return "";
        });
    const setIin = match$2[1];
    const match$3 = React.useState(function () {
          return "";
        });
    const setLastname = match$3[1];
    const match$4 = React.useState(function () {
          return "";
        });
    const setName = match$4[1];
    const match$5 = React.useState(function () {
          return "";
        });
    const setSurname = match$5[1];
    const match$6 = React.useState(function () {
          return "";
        });
    const setPosition = match$6[1];
    const match$7 = React.useState(function () {
          return "";
        });
    const setSalary = match$7[1];
    const salary = match$7[0];
    const match$8 = React.useState(function () {
          return false;
        });
    const setIsBenefit = match$8[1];
    const isBenefit = match$8[0];
    const match$9 = React.useState(function () {
          return false;
        });
    const setIsRetired = match$9[1];
    const isRetired = match$9[0];
    const match$10 = React.useState(function () {
          return "";
        });
    const setRetiredStartDate = match$10[1];
    const match$11 = React.useState(function () {
          return false;
        });
    const setIsRetiredByYearsServed = match$11[1];
    const isRetiredByYearsServed = match$11[0];
    const match$12 = React.useState(function () {
          return "";
        });
    const setRetiredDutyStartDate = match$12[1];
    const match$13 = React.useState(function () {
          return false;
        });
    const setIsDisabled = match$13[1];
    const isDisabled = match$13[0];
    const match$14 = React.useState(function () {
          return "";
        });
    const setDisabledStartDate = match$14[1];
    const match$15 = React.useState(function () {
          return "";
        });
    const setDisabledEndDate = match$15[1];
    const match$16 = React.useState(function () {
          return false;
        });
    const setIsDisabledIndefinitely = match$16[1];
    const isDisabledIndefinitely = match$16[0];
    const match$17 = React.useState(function () {
          return "";
        });
    const setDisabledIndefinitelyStartDate = match$17[1];
    const match$18 = React.useState(function () {
          return false;
        });
    const setIsParent = match$18[1];
    const isParent = match$18[0];
    const match$19 = React.useState(function () {
          return "";
        });
    const setParentBenefitStartDate = match$19[1];
    const match$20 = React.useState(function () {
          return 0;
        });
    const setChildren = match$20[1];
    const match$21 = React.useState(function () {
          return false;
        });
    const setIsMother = match$21[1];
    const isMother = match$21[0];
    const match$22 = React.useState(function () {
          return "";
        });
    const setMotherBenefitStartDate = match$22[1];
    const match$23 = React.useState(function () {
          return false;
        });
    const setIsStudent = match$23[1];
    const isStudent = match$23[0];
    const match$24 = React.useState(function () {
          return "";
        });
    const setStudentBenefitStartDate = match$24[1];
    const match$25 = React.useState(function () {
          return "";
        });
    const setStudentBenefitEndDate = match$25[1];
    React.useEffect((function () {
            if (typeof settings !== "string" && settings.NAME === "Data") {
              const settings$1 = settings.VAL;
              Curry._1(setIin, (function (param) {
                      return settings$1.tin;
                    }));
              Curry._1(setLastname, (function (param) {
                      return settings$1.family_name;
                    }));
              Curry._1(setName, (function (param) {
                      return settings$1.given_name;
                    }));
              Curry._1(setSurname, (function (param) {
                      return Belt__Belt_Option.getWithDefault(settings$1.patronymic_name, "");
                    }));
              Curry._1(setPosition, (function (param) {
                      return Belt__Belt_Option.getWithDefault(settings$1.position, "");
                    }));
              Curry._1(setSalary, (function (param) {
                      const salary = settings$1.salary;
                      if (salary !== undefined) {
                        return salary.rate;
                      } else {
                        return "";
                      }
                    }));
              Curry._1(setBirthday, (function (param) {
                      const date = settings$1.birthday_date;
                      if (date !== undefined) {
                        return Buhta_cabinet__Date.toString(date);
                      } else {
                        return "";
                      }
                    }));
            }
            
          }), [settings]);
    return JsxRuntime.jsxs("form", {
                children: [
                  JsxRuntime.jsx("div", {
                        children: JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsx(Buhta_cabinet__Field.make, {
                                      label: "ИИН",
                                      type_: "text",
                                      name: "iin",
                                      size: "m",
                                      required: true,
                                      onChange: (function (value) {
                                          Curry._1(setIin, (function (param) {
                                                  return value;
                                                }));
                                        }),
                                      value: match$2[0]
                                    }),
                                JsxRuntime.jsxs("div", {
                                      children: [
                                        JsxRuntime.jsx(Buhta_cabinet__Field.make, {
                                              label: "Фамилия",
                                              type_: "text",
                                              name: "lastname",
                                              size: "m",
                                              required: true,
                                              onChange: (function (value) {
                                                  Curry._1(setLastname, (function (param) {
                                                          return value;
                                                        }));
                                                }),
                                              value: match$3[0]
                                            }),
                                        JsxRuntime.jsx(Buhta_cabinet__Field.make, {
                                              label: "Имя",
                                              type_: "text",
                                              name: "name",
                                              size: "m",
                                              required: true,
                                              onChange: (function (value) {
                                                  Curry._1(setName, (function (param) {
                                                          return value;
                                                        }));
                                                }),
                                              value: match$4[0]
                                            }),
                                        JsxRuntime.jsx(Buhta_cabinet__Field.make, {
                                              label: "Отчество",
                                              type_: "text",
                                              name: "surname",
                                              size: "m",
                                              onChange: (function (value) {
                                                  Curry._1(setSurname, (function (param) {
                                                          return value;
                                                        }));
                                                }),
                                              value: match$5[0]
                                            })
                                      ],
                                      className: "flex flex-col md:flex-row gap-4 mt-6"
                                    }),
                                JsxRuntime.jsxs("div", {
                                      children: [
                                        JsxRuntime.jsx(Buhta_cabinet__Field.make, {
                                              label: "Должность",
                                              type_: "text",
                                              name: "position",
                                              size: "m",
                                              onChange: (function (value) {
                                                  Curry._1(setPosition, (function (param) {
                                                          return value;
                                                        }));
                                                }),
                                              value: match$6[0]
                                            }),
                                        JsxRuntime.jsx(Buhta_cabinet__CalendarDatePickerInput.make, {
                                              value: match$1[0],
                                              onPicked: (function (date) {
                                                  Curry._1(setBirthday, (function (param) {
                                                          return DateTime.toDateFormat(date);
                                                        }));
                                                }),
                                              align: "BottomRight",
                                              className: "w-full",
                                              label: "Дата рождения",
                                              tillCurrentDate: true,
                                              displayCurrentDate: false
                                            })
                                      ],
                                      className: "flex flex-col md:flex-row gap-4 mt-6"
                                    }),
                                JsxRuntime.jsxs("div", {
                                      children: [
                                        JsxRuntime.jsx(Buhta_cabinet__Field.make, {
                                              label: "Доход руководителя",
                                              type_: "text",
                                              name: "salary",
                                              size: "m",
                                              required: true,
                                              onChange: (function (value) {
                                                  Curry._1(setSalary, (function (param) {
                                                          return value;
                                                        }));
                                                }),
                                              value: salary.length !== 0 ? MelNumeral.formatInt({
                                                      NAME: "Str",
                                                      VAL: salary
                                                    }) : ""
                                            }),
                                        JsxRuntime.jsx("img", {
                                              className: "absolute right-4 top-4 w-5 h-5",
                                              alt: "tenge",
                                              src: StaticAsset.src("/static/icons/tenge.svg")
                                            })
                                      ],
                                      className: "relative mt-10 md:mt-6"
                                    }),
                                JsxRuntime.jsxs(Buhta_components__Text.Caption.make, {
                                      className: "text-asphalt mt-1",
                                      children: [
                                        "Минимальная сумма — ",
                                        JsxRuntime.jsx("span", {
                                              children: "85 000 ₸",
                                              className: "text-links cursor-pointer",
                                              onClick: (function (param) {
                                                  Curry._1(setSalary, (function (param) {
                                                          return "85000";
                                                        }));
                                                })
                                            })
                                      ]
                                    }),
                                JsxRuntime.jsxs("div", {
                                      children: [
                                        JsxRuntime.jsxs("div", {
                                              children: [
                                                JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                      children: "Применить льготы"
                                                    }),
                                                JsxRuntime.jsx("img", {
                                                      className: "w-5 h-5",
                                                      alt: "info",
                                                      src: StaticAsset.src("/static/icons/info.svg")
                                                    })
                                              ],
                                              className: "flex gap-2 items-center"
                                            }),
                                        JsxRuntime.jsx(Buhta_cabinet__Toggle.make, {
                                              checked: isBenefit,
                                              onChange: (function (value) {
                                                  Curry._1(setIsBenefit, (function (param) {
                                                          return value;
                                                        }));
                                                })
                                            })
                                      ],
                                      className: "flex justify-between items-center mt-6"
                                    }),
                                JsxRuntime.jsxs("div", {
                                      children: [
                                        JsxRuntime.jsx(Buhta_cabinet__Checkbox.make, {
                                              isChecked: isRetired,
                                              onChange: (function (param) {
                                                  Curry._1(setIsRetired, (function (param) {
                                                          return !isRetired;
                                                        }));
                                                }),
                                              text: "Пенсионер по возрасту",
                                              subText: "мужчины — 63, женщины — 61"
                                            }),
                                        JsxRuntime.jsx("div", {
                                              children: JsxRuntime.jsx(Buhta_cabinet__CalendarDatePickerInput.make, {
                                                    value: match$10[0],
                                                    onPicked: (function (date) {
                                                        Curry._1(setRetiredStartDate, (function (param) {
                                                                return DateTime.toDateFormat(date);
                                                              }));
                                                      }),
                                                    align: "BottomLeft",
                                                    label: "Дата начала льготы"
                                                  }),
                                              className: Cn.$plus("mt-2 px-6", Cn.on("hidden", !isRetired))
                                            }),
                                        JsxRuntime.jsxs("div", {
                                              children: [
                                                JsxRuntime.jsx(Buhta_cabinet__Checkbox.make, {
                                                      isChecked: isRetiredByYearsServed,
                                                      onChange: (function (param) {
                                                          Curry._1(setIsRetiredByYearsServed, (function (param) {
                                                                  return !isRetiredByYearsServed;
                                                                }));
                                                        }),
                                                      text: "Пенсионер по выслуге лет"
                                                    }),
                                                JsxRuntime.jsx("img", {
                                                      className: "w-5 h-5",
                                                      alt: "info",
                                                      src: StaticAsset.src("/static/icons/info.svg")
                                                    })
                                              ],
                                              className: "flex gap-2 items-center"
                                            }),
                                        JsxRuntime.jsx("div", {
                                              children: JsxRuntime.jsx(Buhta_cabinet__CalendarDatePickerInput.make, {
                                                    value: match$12[0],
                                                    onPicked: (function (date) {
                                                        Curry._1(setRetiredDutyStartDate, (function (param) {
                                                                return DateTime.toDateFormat(date);
                                                              }));
                                                      }),
                                                    align: "BottomLeft",
                                                    label: "Дата начала льготы"
                                                  }),
                                              className: Cn.$plus("mt-2 px-6", Cn.on("hidden", !isRetiredByYearsServed))
                                            }),
                                        JsxRuntime.jsx(Buhta_cabinet__Checkbox.make, {
                                              isChecked: isDisabled,
                                              onChange: (function (param) {
                                                  Curry._1(setIsDisabled, (function (param) {
                                                          return !isDisabled;
                                                        }));
                                                }),
                                              text: "Инвалид I, II, III группы"
                                            }),
                                        JsxRuntime.jsxs("div", {
                                              children: [
                                                JsxRuntime.jsx("div", {
                                                      children: JsxRuntime.jsx(Buhta_cabinet__CalendarDatePickerInput.make, {
                                                            value: match$14[0],
                                                            onPicked: (function (date) {
                                                                Curry._1(setDisabledStartDate, (function (param) {
                                                                        return DateTime.toDateFormat(date);
                                                                      }));
                                                              }),
                                                            align: "BottomLeft",
                                                            label: "Дата начала льготы"
                                                          }),
                                                      className: "grow"
                                                    }),
                                                JsxRuntime.jsx("div", {
                                                      children: JsxRuntime.jsx(Buhta_cabinet__CalendarDatePickerInput.make, {
                                                            value: match$15[0],
                                                            onPicked: (function (date) {
                                                                Curry._1(setDisabledEndDate, (function (param) {
                                                                        return DateTime.toDateFormat(date);
                                                                      }));
                                                              }),
                                                            align: "BottomLeft",
                                                            label: "Дата окончания"
                                                          }),
                                                      className: "grow"
                                                    })
                                              ],
                                              className: Cn.$plus("mt-2 px-6 flex flex-col md:flex-row gap-4", Cn.on("hidden", !isDisabled))
                                            }),
                                        JsxRuntime.jsx(Buhta_cabinet__Checkbox.make, {
                                              isChecked: isDisabledIndefinitely,
                                              onChange: (function (param) {
                                                  Curry._1(setIsDisabledIndefinitely, (function (param) {
                                                          return !isDisabledIndefinitely;
                                                        }));
                                                }),
                                              text: "Инвалид I, II группы бессрочно"
                                            }),
                                        JsxRuntime.jsx("div", {
                                              children: JsxRuntime.jsx(Buhta_cabinet__CalendarDatePickerInput.make, {
                                                    value: match$17[0],
                                                    onPicked: (function (date) {
                                                        Curry._1(setDisabledIndefinitelyStartDate, (function (param) {
                                                                return DateTime.toDateFormat(date);
                                                              }));
                                                      }),
                                                    align: "BottomLeft",
                                                    label: "Дата начала льготы"
                                                  }),
                                              className: Cn.$plus("mt-2 px-6", Cn.on("hidden", !isDisabledIndefinitely))
                                            }),
                                        JsxRuntime.jsx(Buhta_cabinet__Checkbox.make, {
                                              isChecked: isParent,
                                              onChange: (function (param) {
                                                  Curry._1(setIsParent, (function (param) {
                                                          return !isParent;
                                                        }));
                                                }),
                                              text: "Родитель/опекун инвалида"
                                            }),
                                        JsxRuntime.jsxs("div", {
                                              children: [
                                                JsxRuntime.jsx(Buhta_cabinet__CalendarDatePickerInput.make, {
                                                      value: match$19[0],
                                                      onPicked: (function (date) {
                                                          Curry._1(setParentBenefitStartDate, (function (param) {
                                                                  return DateTime.toDateFormat(date);
                                                                }));
                                                        }),
                                                      align: "BottomLeft",
                                                      className: "md:w-[209px]",
                                                      label: "Дата начала льготы"
                                                    }),
                                                JsxRuntime.jsx(Buhta_cabinet__Field.make, {
                                                      label: "Количество детей",
                                                      type_: "text",
                                                      name: "children",
                                                      size: "m",
                                                      required: true,
                                                      onChange: (function (value) {
                                                          Curry._1(setChildren, (function (param) {
                                                                  try {
                                                                    return Caml_format.caml_int_of_string(value);
                                                                  }
                                                                  catch (exn){
                                                                    return 0;
                                                                  }
                                                                }));
                                                        }),
                                                      className: "md:w-[209px]",
                                                      value: String(match$20[0])
                                                    })
                                              ],
                                              className: Cn.$plus("mt-2 px-6 flex flex-col md:flex-row gap-4", Cn.on("hidden", !isParent))
                                            }),
                                        JsxRuntime.jsx(Buhta_cabinet__Checkbox.make, {
                                              isChecked: isMother,
                                              onChange: (function (param) {
                                                  Curry._1(setIsMother, (function (param) {
                                                          return !isMother;
                                                        }));
                                                }),
                                              text: "Многодетная мать",
                                              subText: "4 и более детей"
                                            }),
                                        JsxRuntime.jsx("div", {
                                              children: JsxRuntime.jsx(Buhta_cabinet__CalendarDatePickerInput.make, {
                                                    value: match$22[0],
                                                    onPicked: (function (date) {
                                                        Curry._1(setMotherBenefitStartDate, (function (param) {
                                                                return DateTime.toDateFormat(date);
                                                              }));
                                                      }),
                                                    align: "BottomLeft",
                                                    label: "Дата начала льготы"
                                                  }),
                                              className: Cn.$plus("mt-2 px-6", Cn.on("hidden", !isMother))
                                            }),
                                        JsxRuntime.jsx(Buhta_cabinet__Checkbox.make, {
                                              isChecked: isStudent,
                                              onChange: (function (param) {
                                                  Curry._1(setIsStudent, (function (param) {
                                                          return !isStudent;
                                                        }));
                                                }),
                                              text: "Студент"
                                            }),
                                        JsxRuntime.jsxs("div", {
                                              children: [
                                                JsxRuntime.jsx(Buhta_cabinet__CalendarDatePickerInput.make, {
                                                      value: match$24[0],
                                                      onPicked: (function (date) {
                                                          Curry._1(setStudentBenefitStartDate, (function (param) {
                                                                  return DateTime.toDateFormat(date);
                                                                }));
                                                        }),
                                                      align: "BottomLeft",
                                                      className: "md:w-[209px]",
                                                      label: "Начало обучения"
                                                    }),
                                                JsxRuntime.jsx(Buhta_cabinet__CalendarDatePickerInput.make, {
                                                      value: match$25[0],
                                                      onPicked: (function (date) {
                                                          Curry._1(setStudentBenefitEndDate, (function (param) {
                                                                  return DateTime.toDateFormat(date);
                                                                }));
                                                        }),
                                                      align: "BottomLeft",
                                                      className: "md:w-[209px]",
                                                      label: "Дата окончания"
                                                    })
                                              ],
                                              className: Cn.$plus("mt-2 px-6 flex flex-col md:flex-row gap-4", Cn.on("hidden", !isStudent))
                                            })
                                      ],
                                      className: Cn.$plus("space-y-4 mt-4", Cn.on("hidden", !isBenefit))
                                    })
                              ],
                              className: "px-6 py-10 md:p-10"
                            }),
                        className: "bg-white min-w-[343px] md:w-[562px] rounded-md"
                      }),
                  JsxRuntime.jsx("div", {
                        children: JsxRuntime.jsx(Buhta_cabinet__Btn.make, {
                              title: "Продолжить",
                              className: "px-6 py-3 w-full md:w-max",
                              type_: "submit"
                            }),
                        className: "md:w-[562px] flex justify-end mt-6"
                      })
                ],
                onSubmit: goToNext
              });
  };
}

function TaxPaymentsSettingsCeo(Props) {
  return make(Props.goToPrevious)(Props.goToNext);
}

const make$1 = TaxPaymentsSettingsCeo;

export {
  make$1 as make,
}
/* Buhta_cabinet__Btn Not a pure module */
